import React, { PureComponent } from 'react';

import InputFieldIconWrapper from 'common/components/InputFieldIconWrapper/InputFieldIconWrapper';
import CalendarIcon from 'common/res/svg/CalendarIcon';
import InputDateField, {
  DATE_PICKER,
} from 'common/components/InputDateField/InputDateField';

class BusBookingDateField extends PureComponent {
  constructor(props) {
    super(props);

    this.handleDateChange = this.handleDateChange.bind(this);
  }
  handleDateChange(newDate) {
    this.props.setDepartureDate(newDate);
  }

  render() {
    const {
      departureDate,
      minimumDateRangeInterval,
      maximumDateRangeInterval,
    } = this.props;

    const minimumDate = new Date();
    minimumDate.setDate(minimumDate.getDate() - minimumDateRangeInterval);

    const maximumDate = new Date();
    maximumDate.setDate(maximumDate.getDate() + maximumDateRangeInterval);

    return (
      <InputFieldIconWrapper Icon={CalendarIcon}>
        <InputDateField
          label="Tanggal Berangkat"
          mode={DATE_PICKER}
          defaultValue={departureDate}
          minimumDate={minimumDate}
          maximumDate={maximumDate}
          format="dddd, DD MMM YYYY"
          onDateChange={this.handleDateChange}
        />
      </InputFieldIconWrapper>
    );
  }
}

export default BusBookingDateField;
